import RootLayout from "./layouts/root-layout";
import ScrollToTop from "./globals/scroll-to-top";
import { StudentAuthProvider } from "./app/pannels/public-user/context/StudentAuthContext";

function App() {
  return (
    <StudentAuthProvider>
      <ScrollToTop />
      <RootLayout />
    </StudentAuthProvider>
  )
}

export default App;